// ─── Feuille : ajouter un article MANUEL à la liste de courses ────
import React, { useEffect, useMemo, useState } from 'react';
import { View, Text, TextInput, StyleSheet } from 'react-native';
import { Feuille, stylesForm, useUI, useT } from '@mop/core';

const VIDE = { nom: '', quantite: '', unite: '' };

export default function FeuilleItemCourse({ visible, onEnregistrer, onFermer }) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => StyleSheet.create({ ...stylesForm(UI), row: { flexDirection: 'row', gap: 8 } }), [UI]);
  const [f, setF] = useState(VIDE);

  useEffect(() => { if (visible) setF(VIDE); }, [visible]);

  const set = (k, v) => setF(x => ({ ...x, [k]: v }));
  const valide = !!(f.nom || '').trim();

  return (
    <Feuille visible={visible} titre={t('courses.ajouterArticle')} emoji="🛒" hauteur={0.45} onFermer={onFermer}
      action={{ icone: '＋', label: t('commun.enregistrer'), disabled: !valide, onPress: () => onEnregistrer(f) }}>

      <Text style={s.lbl}>{t('commun.nom')}</Text>
      <TextInput style={s.input} value={f.nom} onChangeText={v => set('nom', v)}
        placeholder={t('repas.phIngredient')} placeholderTextColor={UI.faint} />

      <View style={s.row}>
        <View style={{ flex: 1 }}>
          <Text style={s.lbl}>{t('repas.qte')}</Text>
          <TextInput style={s.input} value={f.quantite} onChangeText={v => set('quantite', v)}
            placeholder="1" placeholderTextColor={UI.faint} />
        </View>
        <View style={{ flex: 1 }}>
          <Text style={s.lbl}>{t('repas.unite')}</Text>
          <TextInput style={s.input} value={f.unite} onChangeText={v => set('unite', v)}
            placeholder="g, L, pièce…" placeholderTextColor={UI.faint} />
        </View>
      </View>
    </Feuille>
  );
}
